var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowRightFromBracket = function SvgArrowRightFromBracket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-from-bracket"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.71429 20.0357C9.71429 20.5701 9.28437 21 8.75 21H5.85714C3.72687 21 2 19.2731 2 17.1429V6.85714C2 4.72687 3.72687 3 5.85714 3H8.75C9.28437 3 9.71429 3.43152 9.71429 3.96429C9.71429 4.49665 9.28437 4.92857 8.75 4.92857H5.85714C4.79643 4.92857 3.92857 5.79643 3.92857 6.85714V17.1429C3.92857 18.2036 4.79643 19.0714 5.85714 19.0714H8.75C9.28437 19.0714 9.71429 19.5013 9.71429 20.0357ZM22.3103 11.3411L17.2036 5.87679C16.8382 5.48754 16.228 5.47018 15.8411 5.83536C15.4532 6.19946 15.4345 6.80969 15.7997 7.19782L19.3732 11.0357H9.3567C8.85848 11.0357 8.42857 11.4696 8.42857 12C8.42857 12.5304 8.86049 12.9643 9.3567 12.9643H19.3371L15.7242 16.8038C15.3588 17.1917 15.3777 17.8018 15.7656 18.1662C15.9902 18.3402 16.2272 18.4286 16.4281 18.4286C16.6843 18.4286 16.9404 18.3269 17.13 18.1247L22.2367 12.6605C22.6598 12.2893 22.6598 11.7107 22.3103 11.3411Z",
    fill: "#555555"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRightFromBracket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right-from-bracket.f0c333b5.svg";
export { ForwardRef as ReactComponent };